export default __webpack_public_path__ + "static/media/icon.3817692b.svg";